export const LOCATION_CARD_STYLE = {
  background: "rgba(0,0,0,0.28)",
  border: "1px solid rgba(201,168,76,0.48)",
  borderRadius: "16px",
  padding: "20px",
  marginBottom: "32px",
};

export const LOCATION_HEADER_STYLE = {
  marginBottom: "20px",
  paddingBottom: "16px",
  borderBottom: "1px solid rgba(201,168,76,0.22)",
};

export const LOCATION_NAME_STYLE = {
  fontSize: "20px",
  fontWeight: 700,
  letterSpacing: "0.02em",
  color: "#f0e6cc",
  marginBottom: "12px",
};

export const GROUP_CARD_STYLE = {
  padding: "14px 16px",
  marginBottom: "14px",
  borderRadius: "12px",
  border: "1px solid rgba(201,168,76,0.24)",
  background: "rgba(0,0,0,0.2)",
};

export const GROUP_CARD_ADD_STYLE = {
  padding: "14px 16px",
  marginBottom: "0",
  borderRadius: "12px",
  border: "1px dashed rgba(201,168,76,0.32)",
  background: "rgba(0,0,0,0.12)",
};

export const GROUP_TITLE_STYLE = {
  fontWeight: 600,
  fontSize: "14px",
  marginBottom: "10px",
  color: "#c9a84c",
};

export const ROW_STYLE = {
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "1px solid rgba(201,168,76,0.18)",
  background: "rgba(0,0,0,0.16)",
};

export const PANEL_CARD_STYLE = {
  marginTop: "24px",
  padding: "20px",
  borderRadius: "14px",
  border: "1px solid rgba(201,168,76,0.38)",
  background: "#2a2e32",
  boxShadow:
    "inset 0 1px 0 rgba(255,255,255,0.04), 0 2px 10px rgba(0,0,0,0.22)",
};

export const PANEL_TITLE_STYLE = {
  fontWeight: 700,
  fontSize: "17px",
  letterSpacing: "0.02em",
  color: "#c9a84c",
};

export const PANEL_DIVIDER_STYLE = {
  height: "1px",
  background: "rgba(201,168,76,0.32)",
  margin: "12px 0 18px",
};

export const SUBTOTAL_STYLE = {
  marginTop: "4px",
  padding: "10px 12px",
  borderRadius: "10px",
  border: "1px solid rgba(201,168,76,0.28)",
  background: "rgba(201,168,76,0.06)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "14px",
};

export const TOTAL_CARD_STYLE = {
  marginTop: "32px",
  padding: "20px 22px",
  borderRadius: "16px",
  border: "2px solid rgba(201,168,76,0.72)",
  background: "rgba(201,168,76,0.12)",
  boxShadow: "0 0 0 1px rgba(201,168,76,0.12), 0 4px 14px rgba(0,0,0,0.2)",
};

export const WORK_TYPE_CARD_STYLE = {
  marginBottom: "16px",
  borderRadius: "12px",
  border: "1px solid rgba(201,168,76,0.35)",
  background: "rgba(0,0,0,0.18)",
  overflow: "hidden",
};

export const ACTION_BTN = {
  padding: "10px 16px",
  borderRadius: "10px",
  border: "1px solid rgba(201,168,76,0.45)",
  background: "rgba(201,168,76,0.12)",
  color: "#c9a84c",
  fontSize: "14px",
  fontWeight: 600,
  cursor: "pointer",
};

export const ACTION_BTN_SM = {
  ...ACTION_BTN,
  padding: "8px 14px",
  fontSize: "13px",
};

export const DANGER_BTN = {
  ...ACTION_BTN,
  border: "1px solid rgba(224,107,90,0.45)",
  background: "rgba(224,107,90,0.12)",
  color: "#e06b5a",
};

export const DANGER_BTN_SM = {
  ...DANGER_BTN,
  padding: "8px 14px",
  fontSize: "13px",
};
